// @flow strict

import * as React from "react";

class PlayGround extends React.Component {
    state={
        hell:"hellow"
    }
  render() {
    return <div>Helllo</div>;
  }
}

export default PlayGround;
